import { ExternalLink } from 'lucide-react';
import type { ReactElement } from 'react';

import { usePermission } from '@/hooks/usePermission';
import { env } from '@/lib/env';

/** Acceso al administrador del LMS (pedido de Calidad: ir y volver entre ambos sistemas).
 *  Solo para quien administra usuarios o roles, y solo si la dirección está configurada.
 *  Pestaña nueva con noopener/noreferrer: el LMS no recibe acceso a esta ventana. */
export function LmsAdminLink(): ReactElement | null {
  const canUsers = usePermission('system:users:manage');
  const canRoles = usePermission('system:roles:manage');
  const url = env.VITE_LMS_ADMIN_URL;
  if (!url || !(canUsers || canRoles)) {
    return null;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Administrador del LMS (se abre en una pestaña nueva)"
    >
      <ExternalLink aria-hidden="true" size={16} />
      Administrador del LMS
    </a>
  );
}
